'use client';

import React, { type ReactNode } from 'react';

import { Body } from '@depop/web-thrift-ui/Typography';
import { ButtonLink } from '@depop/web-ui-kit/ButtonLink';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ButtonExperiment } from '@/components/ButtonExperiment';
import { ExtendedLink } from '@/components/ExtendedLink';
import { ActivityTrackerEventType } from '@/modules/activityTracker/constants';
import { useActivityTracker } from '@/modules/activityTracker/useActivityTracker';
import { useRedirectQueryParam } from '@/modules/auth/useRedirectQueryParam';
import { MagicLinkType } from '@/modules/login/types';

function LegacyContinueWithEmail({
  className,
  children,
}: {
  className?: string;
  children?: ReactNode;
}) {
  return (
    <ButtonLink variant className={className}>
      <Body as="span" variant="sm-regular">
        {children}
      </Body>
    </ButtonLink>
  );
}

export function EmailMagicLinkButton({ type }: { type: MagicLinkType }) {
  const t = useTranslations('magicLinks');
  const { sendActivityTrackerEvent } = useActivityTracker();
  const queryParams = useRedirectQueryParam();

  const magicLinkPath = `/magic-link/${queryParams}`;

  function handleLinkClick() {
    if (type === MagicLinkType.LOGIN) {
      sendActivityTrackerEvent(ActivityTrackerEventType.LOGIN_WELCOME_ACTION, {
        schemaVersion: '1.0',
        actionType: 'usernameEmail',
      });
    } else {
      sendActivityTrackerEvent(ActivityTrackerEventType.SIGNUP_SUBMIT_ACTION, {
        schemaVersion: '1.0',
        loginType: 'usernameEmail',
      });
    }
  }

  return (
    <ExtendedLink
      href={magicLinkPath}
      onClick={handleLinkClick}
      className={styles.continueWithEmailLink}
    >
      <ButtonExperiment
        as="span"
        variant="tertiary"
        legacyComponent={LegacyContinueWithEmail}
      >
        {t('Auth.ContinueWithEmail')}
      </ButtonExperiment>
    </ExtendedLink>
  );
}
